import React, { memo, useState } from 'react'

import { GameWithUserInformation } from '../../containers/GamesBlock/types'
import { Hover } from './Hover'
import Icons from './Icons'
import Image from './Image'
import TitleWithFavoriteIcon from './TitleWithFavoriteIcon'
import GameWrapper from './styles/GameWrapper'

interface GameProps {
  game: GameWithUserInformation
  size?: number
}

function Game({ game, size }: GameProps) {
  const [hover, setIsHover] = useState(false)
  const { imagePath, badges, slug, name, isFavorite } = game

  return (
    <GameWrapper
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
      size={size}
    >
      <Icons game={game} />
      <Image
        src={imagePath}
        hover={hover}
        badges={badges}
      />
      <Hover
        hover={hover}
        game={game}
        small
      />
      <TitleWithFavoriteIcon
        slug={slug}
        name={name}
        isFavorite={isFavorite}
      />
    </GameWrapper>
  )
}

export default memo(Game)
